import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-html-to-pdf',
    imports: [],
    templateUrl: './blog-html-to-pdf.component.html',
    styleUrl: './blog-html-to-pdf.component.css'
})
export class BlogHtmlToPdfComponent {

}
